// extracted by mini-css-extract-plugin
export default {"content":"OverView_content__lcHoh"};